import { useState, useEffect } from 'react';

function usePortal(portalName = 'body') {
  const [portal, setPortal] = useState<Element | null>(null);

  useEffect(() => {
    setPortal(document.querySelector(`.portal-${portalName}`));
  }, [portalName]);

  return portal;
}

export default usePortal;
